import moment from "moment";

export const ORDER_VIEW_COLUMNS = [
  {
    Header: "INVC #",
    accessor: "InvoiceNumber",
    id: "InvoiceNumber"
  },
  {
    Header: "INVC DATE",
    accessor: "InvoiceDate",
    id: "InvoiceDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : ""
  },
  {
    Header: "Bill To #",
    accessor: "BillToNumber",
    id: "BillToNumber"
  },
  {
    Header: "Bill To Name",
    accessor: "BillToName",
    id: "BillToName"
  },
  {
    Header: "Customer #",
    accessor: "CustomerNo",
    id: "CustomerNo"
  },
  {
    Header: "Customer Name",
    accessor: "CustomerName",
    id: "CustomerName"
  },
  {
    Header: "Order #",
    accessor: "OrderNumber",
    id: "OrderNumber"
  },
  {
    Header: "INVC BATCH #",
    accessor: "InvoiceBatchNumber",
    id: "InvoiceBatchNumber"
  },
  {
    Header: "Pickup Date",
    accessor: "PickupDate",
    id: "PickupDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Status",
    accessor: "StatusIdDescription",
    id: "StatusIdDescription"
  },
  {
    Header: "",
    accessor: "StatusIdListOrder",
    id: "StatusIdListOrder"
  },
  {
    Header: "Pickup ID",
    accessor: "Pickup_LocationId",
    id: "PickupLocationID"
  },
  {
    Header: "Pickup Location",
    accessor: "PickUp_LocationName",
    id: "Pickup_LocationId"
  },
  {
    Header: "City",
    accessor: "PickUp_City",
    id: "PickUp_City"
  },
  {
    Header: "State",
    accessor: "PickUp_State",
    id: "PickUp_State"
  },
  {
    Header: "Delivery ID",
    accessor: "Del_LocationId",
    id: "DeliveryLocationID"
  },
  {
    Header: "Delivery Location",
    accessor: "Del_LocationName",
    id: "Del_LocationName"
  },
  {
    Header: "City",
    accessor: "Del_City",
    id: "Del_City"
  },
  {
    Header: "State",
    accessor: "Del_State",
    id: "Del_State"
  },
  {
    Header: "Driver Id",
    accessor: "PickupDriver",
    id: "PickupDriver"
  },
  {
    Header: "Driver Name",
    accessor: "PickupDriverLastName",
    id: "PickupDriverLastName"
  },
  {
    Header: "Tractor",
    accessor: "PickupTractor",
    id: "PickupTractor"
  },
  {
    Header: "Trailer",
    accessor: "PickupTrailer",
    id: "PickupTrailer"
  },
  {
    Header: "Order Date",
    accessor: "OrderDate",
    id: "OrderDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Verified By",
    accessor: "VerifiedByUserId",
    id: "VerifiedByUserId"
  },
  {
    Header: "Created Date",
    accessor: "CreatedDateTime",
    id: "CreatedDateTime",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY HH:mm") : null
  },
  {
    Header: "Created By",
    accessor: "CreatedBy",
    id: "CreatedBy"
  },
  {
    Header: "Modified Date",
    accessor: "ModifiedDateTime",
    id: "ModifiedDateTime",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Modified By",
    accessor: "ModifiedBy",
    id: "ModifiedBy"
  }
];
